import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideOut16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconArrowSlideOut16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M6.184 2.96c1.47.075 2.773.78 3.647 1.85l-.852.856a3.847 3.847 0 1 0-3.056 6.18c1.24 0 2.342-.589 3.045-1.5l.855.852a5.03 5.03 0 0 1-3.9 1.848l-.259-.007a5.046 5.046 0 0 1-4.78-4.78L.877 8a5.047 5.047 0 0 1 5.047-5.047zm6.02 2.897a.6.6 0 0 1 .849 0l2.134 2.135-2.135 2.136a.6.6 0 1 1-.848-.848l.692-.692H8.6a.6.6 0 1 1 0-1.2h4.287l-.683-.682a.6.6 0 0 1 0-.849"
            />
        </svg>
    );
}
export default memo(IconArrowSlideOut16);
